<template>
  <svg :fill="color" viewBox="0 0 28 32" xmlns="http://www.w3.org/2000/svg">
    <path d="M28,12H0v17c0,1.66,1.34,3,3,3h22c1.66,0,3-1.34,3-3V12ZM6,2v2h-3c-1.66,0-3,1.34-3,3v3h28v-3c0-1.66-1.34-3-3-3h-3v-2c0-1.11-.89-2-2-2s-2,.89-2,2v2h-8v-2c0-1.11-.89-2-2-2s-2,.89-2,2Z"/>
  </svg>
</template>

<script>
export default {
  name: 'IconClock',
  props: {
    color: {
      type: String,
      default: '#24b9ec'
    }
  }
}
</script>
